import type { CustomerStatementParty, CustomerStatementReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';

/** A customer is per till: the till (device) and its own customer id together. */
export interface StatementPartyRef {
  deviceId: string;
  sourceId: number;
}

/** Under `['reports', ...]` so anything invalidating `reportKeys.all` refreshes these too. */
export const customerStatementKeys = {
  customers: (branchId: string, search: string) => ['reports', 'customer-statement', 'customers', branchId, search] as const,
  statement: (party: StatementPartyRef | null, from: string, to: string) =>
    ['reports', 'customer-statement', party?.deviceId, party?.sourceId, from, to] as const,
};

export function fetchStatementCustomers(
  branchId: string,
  search: string,
  signal?: AbortSignal,
): Promise<CustomerStatementParty[]> {
  return portalApi.get<CustomerStatementParty[]>(
    `/portal/reports/customer-statement/customers${queryString({ branchId, search })}`,
    { signal },
  );
}

export function fetchCustomerStatement(
  party: StatementPartyRef,
  range: { from: string; to: string },
  signal?: AbortSignal,
): Promise<CustomerStatementReport> {
  return portalApi.get<CustomerStatementReport>(
    `/portal/reports/customer-statement${queryString({ deviceId: party.deviceId, sourceId: party.sourceId, from: range.from, to: range.to })}`,
    { signal },
  );
}
